/**
 * Selleasy Upsell Line Item Property Injector
 *
 * Intercepts the Selleasy upsell "Add" button and injects a line item property
 * with the current product's title (e.g., "Upsold From: Product Name")
 */
(function() {
  'use strict';

  // Get the current product title from the page
  function getCurrentProductTitle() {
    // Try the product title element first
    const titleElement = document.querySelector('.product-detail h1.title, .product-single h1.title, h1.product-title');
    if (titleElement) {
      return titleElement.textContent.trim();
    }

    // Try the product JSON data
    const productJsonScript = document.querySelector('script[id^="ProductJson-"]');
    if (productJsonScript) {
      try {
        const productData = JSON.parse(productJsonScript.textContent);
        if (productData && productData.title) {
          return productData.title;
        }
      } catch (e) {
        console.warn('Failed to parse product JSON:', e);
      }
    }

    // Fallback to meta tag
    const metaTitle = document.querySelector('meta[property="og:title"]');
    if (metaTitle) {
      return metaTitle.getAttribute('content');
    }

    return null;
  }

  // Get the _bundle_selection property from the main product form
  function getBundleSelection() {
    // Try to find the bundle selection input in the product form
    const bundleInput = document.querySelector('input[name="properties[_bundle_selection]"], input[name="properties[_Bundle Selection]"]');
    if (bundleInput && bundleInput.value) {
      return bundleInput.value;
    }

    // Try hidden inputs with bundle in the name
    const hiddenInputs = document.querySelectorAll('form.product-purchase-form input[type="hidden"], form[action*="/cart/add"] input[type="hidden"]');
    for (const input of hiddenInputs) {
      if (input.name && input.name.toLowerCase().includes('bundle') && input.value) {
        return input.value;
      }
    }

    // Try to get from any form field that might contain bundle selection
    const allBundleInputs = document.querySelectorAll('[name*="bundle" i], [name*="_bundle_selection" i]');
    for (const input of allBundleInputs) {
      if (input.value) {
        return input.value;
      }
    }

    return null;
  }

  // Store the original fetch function
  const originalFetch = window.fetch;

  // Override fetch to intercept cart/add requests
  window.fetch = function(url, options) {
    // Check if this is a cart add request
    if (url && (url.includes('/cart/add') || url.includes('cart/add.js'))) {
      const productTitle = getCurrentProductTitle();
      const bundleSelection = getBundleSelection();

      if (productTitle && options && options.body) {
        try {
          let body;

          // Handle different body formats
          if (typeof options.body === 'string') {
            body = JSON.parse(options.body);
          } else if (options.body instanceof FormData) {
            // Convert FormData to object
            body = {};
            for (let [key, value] of options.body.entries()) {
              body[key] = value;
            }
          } else {
            body = options.body;
          }

          // Check if this is likely from Selleasy (has items array or is a single item add)
          // We'll be conservative and only add property if the request originates from clicking
          // a Selleasy button (tracked via a flag)
          if (window.__selleasyUpsellClick) {
            // Build the properties to add
            var propsToAdd = {
              'For Product': productTitle
            };
            if (bundleSelection) {
              propsToAdd['_bundle_selection'] = bundleSelection;
            }

            // Add the line item properties
            if (body.items && Array.isArray(body.items)) {
              // Multiple items format
              body.items = body.items.map(item => ({
                ...item,
                properties: {
                  ...(item.properties || {}),
                  ...propsToAdd
                }
              }));
            } else if (body.id || body.quantity) {
              // Single item format
              body.properties = {
                ...(body.properties || {}),
                ...propsToAdd
              };
            }

            // Clear the flag
            window.__selleasyUpsellClick = false;

            // Reconstruct the options with modified body
            options = {
              ...options,
              body: JSON.stringify(body)
            };

            // Make sure content-type is JSON
            if (!options.headers) {
              options.headers = {};
            }
            if (options.headers instanceof Headers) {
              options.headers.set('Content-Type', 'application/json');
            } else {
              options.headers['Content-Type'] = 'application/json';
            }
          }
        } catch (e) {
          console.warn('Selleasy upsell property injection failed:', e);
        }
      }
    }

    return originalFetch.apply(this, arguments);
  };

  // Also intercept XMLHttpRequest for older implementations
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    this._method = method;
    return originalXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function(body) {
    if (this._url && (this._url.includes('/cart/add') || this._url.includes('cart/add.js'))) {
      const productTitle = getCurrentProductTitle();
      const bundleSelection = getBundleSelection();

      if (productTitle && body && window.__selleasyUpsellClick) {
        try {
          let parsedBody;

          if (typeof body === 'string') {
            parsedBody = JSON.parse(body);
          } else {
            parsedBody = body;
          }

          // Build the properties to add
          var propsToAdd = {
            'For Product': productTitle
          };
          if (bundleSelection) {
            propsToAdd['_bundle_selection'] = bundleSelection;
          }

          // Add the line item properties
          if (parsedBody.items && Array.isArray(parsedBody.items)) {
            parsedBody.items = parsedBody.items.map(item => ({
              ...item,
              properties: {
                ...(item.properties || {}),
                ...propsToAdd
              }
            }));
          } else if (parsedBody.id || parsedBody.quantity) {
            parsedBody.properties = {
              ...(parsedBody.properties || {}),
              ...propsToAdd
            };
          }

          window.__selleasyUpsellClick = false;
          body = JSON.stringify(parsedBody);
          this.setRequestHeader('Content-Type', 'application/json');
        } catch (e) {
          console.warn('Selleasy upsell XHR property injection failed:', e);
        }
      }
    }

    return originalXHRSend.call(this, body);
  };

  // Listen for clicks on Selleasy add buttons
  function attachClickListeners() {
    document.addEventListener('click', function(e) {
      // Check if the clicked element is a Selleasy add button
      const selleasyBtn = e.target.closest('.lb-spc-details-btn, .lb-spc-cta-btn, [class*="lb-spc"][class*="btn"]');

      if (selleasyBtn) {
        // Set the flag to indicate this is a Selleasy upsell add
        window.__selleasyUpsellClick = true;

        // Clear the flag after a short delay if no cart request happens
        setTimeout(function() {
          window.__selleasyUpsellClick = false;
        }, 3000);
      }
    }, true); // Use capture phase to catch it early
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachClickListeners);
  } else {
    attachClickListeners();
  }

})();
